import { module } from 'angular';

import { default as mediaPlayerName, MediaPlayer } from './media-player.component.ajs';

export default module('contact.commons.toolbox.media-player', ['ngAudio']).component(mediaPlayerName, new MediaPlayer()).name;
